<div class="row">
  <div class="col-md-8">
    <div class="row"></div>
    <div class="row">
      <div class="mb-3">
        <label for="filtrarPaciente" class="form-label"
          >Filtrar Especialistas:</label
        >
        <input
          type="text"
          class="form-control"
          placeholder="Ingrese nombre del especialista..."
          [(ngModel)]="filtroEspecialista"
          (input)="filtrarEspecialistas()"
        />
      </div>

      <div *ngIf="!cargandoEspecialistas && especialistasFiltrados.length > 0">
        <div
          *ngIf="!spinner"
          class="row"
          data-masonry='{"percentPosition": true }'
        >
          <ng-container
            *ngFor="let data of filtroEspecialistaTraidos; let last = last"
            class="row"
          >
            <div class="col-12 mobile-card-container">
              <div class="card h-100 border-box">
                <div class="row">
                  <!-- Información del especialista - izquierda -->
                  <div class="col-md-4">
                    <div
                      class="d-flex align-items-start p-3 p-md-3 px-md-3 px-2"
                    >
                      <div class="image-container me-md-3 me-2">
                        <img
                          src="{{ data.foto }}"
                          alt="{{ data.nombre }}"
                          class="rounded-circle"
                          style="width: 70px; height: 70px; object-fit: cover"
                        />
                      </div>
                      <div class="flex-grow-1">
                        <h5 class="nombre-title mb-1">{{ data.nombre }}</h5>
                        <p class="nombre-subtitle mb-2 text-muted">
                          {{ data.perfil.especialidad }}
                        </p>
                      </div>
                    </div>
                    <app-expandable-text
                      [text]="data.descripcion"
                      [maxLength]="100"
                    ></app-expandable-text>
                  </div>

                  <div class="col-md-8">
                    <app-agenda-especialista
                      [idEspecialista]="data.$id"
                      [datosPaciente]="datosPaciente"
                    ></app-agenda-especialista>
                  </div>
                </div>
              </div>
              <!-- Separador solo para móviles -->
              <div *ngIf="!last" class="mobile-separator d-md-none"></div>
            </div>
          </ng-container>
        </div>
      </div>
      <a
        *ngIf="hayMasEspecialistas"
        href="javascript: void(0);"
        (click)="onTraerTodosEspecialistas()"
        class="btn-traer-especialistas"
        >Traer Todos los especialistas</a
      >
    </div>
  </div>
</div>
